import React, { useState, FormEvent } from 'react';
import '../styles/ChangePasswordForm.css';

interface Props {
    userId: string;
    username: string;
    onSubmit: (id: string, newPassword: string) => Promise<void>;
    onCancel: () => void;
}

export default function ChangePasswordForm({
                                               userId,
                                               username,
                                               onSubmit,
                                               onCancel
                                           }: Props) {
    const [newPassword, setNewPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        setError('');
        if (newPassword.length < 8) {
            setError('Password must be at least 8 characters');
            return;
        }
        try {
            await onSubmit(userId, newPassword);
            onCancel();
        } catch (err: any) {
            setError(err.response?.data?.message || err.message);
        }
    };

    return (
        <div className="user-form-overlay">
            <div className="user-form-container">
                <div className="user-form-header">
                    <h1 className="user-form-title">
                        Reset Password for {username}
                    </h1>
                </div>
                {error && <div className="user-form-error">{error}</div>}

                <form className="user-form-grid" onSubmit={handleSubmit}>
                    <div className="user-form-group" style={{ gridColumn: '1/-1' }}>
                        <label className="user-form-label" htmlFor="new-password">
                            New Password
                        </label>
                        <input
                            id="new-password"
                            type="password"
                            className="user-form-input"
                            value={newPassword}
                            onChange={e => setNewPassword(e.target.value)}
                            required
                            minLength={8}
                            placeholder="Enter new password"
                            autoComplete="new-password"
                        />
                    </div>
                    <div className="user-button-group" style={{ gridColumn: '1/-1' }}>
                        <button
                            type="button"
                            className="user-btn user-btn-cancel"
                            onClick={onCancel}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="user-btn user-btn-save"
                        >
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
